import {
  IProviderNetworkCompanyAPIResponse,
  ProviderNetworkCompany
} from './provider-network-company.model';

interface IMemberProviderNetworkCompany {
  id: number;
  acceptingClients: boolean;
  approved: boolean;
  canSubmitSuperbills: boolean;
  networkStatus: string;
  providerNetworkCompany: ProviderNetworkCompany;
}

export interface IMemberProviderNetworkCompanyAPIResponse {
  id: number;
  accepting_clients: boolean;
  approved: boolean;
  can_submit_superbills: boolean;
  network_status: string;
  provider_network_company: IProviderNetworkCompanyAPIResponse;
}

export class MemberProviderNetworkCompany implements IMemberProviderNetworkCompany {
  id: number;
  acceptingClients: boolean;
  approved: boolean;
  canSubmitSuperbills: boolean;
  networkStatus: string;
  providerNetworkCompany: ProviderNetworkCompany;

  constructor(json: IMemberProviderNetworkCompanyAPIResponse) {
    this.id = json.id;
    this.acceptingClients = json.accepting_clients;
    this.approved = json.approved;
    this.canSubmitSuperbills = json.can_submit_superbills;
    this.networkStatus = json.network_status;
    this.providerNetworkCompany = new ProviderNetworkCompany(json.provider_network_company);
  }
}
